
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/arrow-3"}},[_c('g',{attrs:{"data-name":"Group 125","opacity":".4"}},[_c('path',{attrs:{"d":"M10.45 6.72L6.73 3 3.01 6.72"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.73 21V3"}})]),_c('path',{attrs:{"data-name":"Vector","d":"M13.55 17.28L17.27 21l3.72-3.72M17.27 3v18"}})])])
          )
        }
      }
    